import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function LimitedEditionBanner() {
  return <div className="w-full px-4 pt-4 sm:pt-6 flex justify-center relative z-50" data-id="element-102">
      <motion.div initial={{
      y: -50,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="relative overflow-hidden bg-emerald-900/60 backdrop-blur-md border border-gold-500/30 shadow-[0_0_20px_rgba(212,175,55,0.15)] rounded-2xl py-3 px-6 md:px-8 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 max-w-3xl w-full group" data-id="element-103">
        {/* Subtle shimmer background effect */}
        <div className="absolute inset-0 -translate-x-full animate-[shimmer_3s_infinite] bg-gradient-to-r from-transparent via-white/5 to-transparent pointer-events-none" data-id="element-104" />

        <div className="flex items-center gap-2" data-id="element-105">
          <motion.div animate={{
          scale: [1, 1.2, 1],
          rotate: [0, 5, -5, 0]
        }} transition={{
          duration: 2.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-106">
            <Sparkles className="w-4 h-4 md:w-5 md:h-5 text-gold-400" data-id="element-107" />
          </motion.div>
          <span className="font-heading font-bold text-transparent bg-clip-text bg-gradient-to-r from-gold-400 to-gold-300 tracking-wider text-sm md:text-base whitespace-nowrap" data-id="element-108">
            EDICIÓN LIMITADA
          </span>
        </div>

        <div className="hidden sm:block w-px h-5 bg-gold-500/30" data-id="element-109" />

        <p className="font-body text-emerald-100/90 text-xs md:text-sm text-center" data-id="element-110">
          Solo disponible por tiempo limitado —{' '}
          <span className="text-white font-medium" data-id="element-111">¡No te lo pierdas!</span>
        </p>
      </motion.div>
    </div>;
}